import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const SearchResults = styled.div`
  margin: 0 auto;
  padding-left: 16px;
  padding-right: 8px;
`

export const SearchResultsItem = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.white};
  z-index: 1000;
  cursor: pointer;
  transition: background-color 0.2s ease-out;
  padding-top: 11px;
  padding-bottom: 11px;

  @media ${device.mobileMin} {
    padding-top: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${colors.greyBlue};
  }
`
